"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createWofSlice = exports.createWofOptions = void 0;
var wof_template3_png_1 = __importDefault(require("../assets/wof/wof_template3.png"));
var DEFAULT_FONT_FAMILY = "Montserrat, sans-serif";
var createWofOptions = function (options) {
    var _a, _b, _c, _d;
    return ({
        options: (options === null || options === void 0 ? void 0 : options.options) || [],
        borderColor: (options === null || options === void 0 ? void 0 : options.borderColor) || "#A5873E",
        borderWidth: (_a = options === null || options === void 0 ? void 0 : options.borderWidth) !== null && _a !== void 0 ? _a : 4,
        drawAngle: (_b = options === null || options === void 0 ? void 0 : options.drawAngle) !== null && _b !== void 0 ? _b : 315,
        skinPath: (options === null || options === void 0 ? void 0 : options.skinPath) || wof_template3_png_1.default,
        imageFrameClass: (options === null || options === void 0 ? void 0 : options.imageFrameClass) || "",
        insideRadius: (_c = options === null || options === void 0 ? void 0 : options.insideRadius) !== null && _c !== void 0 ? _c : 46,
        loading: (options === null || options === void 0 ? void 0 : options.loading) || false,
        onSpinStop: options === null || options === void 0 ? void 0 : options.onSpinStop,
        rootClass: (options === null || options === void 0 ? void 0 : options.rootClass) || "",
        showIndicator: (options === null || options === void 0 ? void 0 : options.showIndicator) || false,
        sliceColor: (options === null || options === void 0 ? void 0 : options.sliceColor) || "#222222",
        spinAction: options === null || options === void 0 ? void 0 : options.spinAction,
        spinSpeed: options === null || options === void 0 ? void 0 : options.spinSpeed,
        startAngle: options === null || options === void 0 ? void 0 : options.startAngle,
        width: (_d = options === null || options === void 0 ? void 0 : options.width) !== null && _d !== void 0 ? _d : 440,
        winnerSliceColor: (options === null || options === void 0 ? void 0 : options.winnerSliceColor) || "#A5873E",
        prizeIndex: (options === null || options === void 0 ? void 0 : options.prizeIndex) || 0,
        children: (options === null || options === void 0 ? void 0 : options.children) || null
    });
};
exports.createWofOptions = createWofOptions;
var createWofSlice = function (slice) {
    var _a, _b, _c;
    return ({
        values: (_a = slice === null || slice === void 0 ? void 0 : slice.values) !== null && _a !== void 0 ? _a : [],
        style: (_b = slice === null || slice === void 0 ? void 0 : slice.style) !== null && _b !== void 0 ? _b : [{
                color: "#A5873E",
                fontFamily: DEFAULT_FONT_FAMILY,
                fontWeight: "bold",
                fontSize: 16,
                marginTop: 100,
            }],
        highlightStyle: (_c = slice === null || slice === void 0 ? void 0 : slice.highlightStyle) !== null && _c !== void 0 ? _c : [
            {
                color: "white",
                fontFamily: DEFAULT_FONT_FAMILY,
                fontWeight: "bold",
                fontSize: 16,
                marginTop: 100,
            },
        ],
    });
};
exports.createWofSlice = createWofSlice;
